import CreateTabs from "common/components/createTabs";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { Box, Button, Input, Spinner, Textarea } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { postApi } from "common/services/api";
import { generateValidationSchema } from "services/Crm/utils";
import * as yup from "yup";
import { singularizeLastWord } from "services/Crm/utils/calcUtils";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import CustomForm from "common/utils/customForm";
import { getApi } from "common/services/api";
import { crmConstant } from "services/Crm/constant";

const TaskInformation = (props) => {
  const hash = window.location.hash;
  const path = hash.replace("#", "").split("/");
  const title = path[2].replace(/-/g, " ");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [dealRelatedFields, setDealRelatedFields] = useState({});

  const initialFieldValues = Object.fromEntries(
    (props?.moduleData?.fields || []).map((field) => [field?.name, ""])
  );

  const initialValues = {
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  };
  const handleBackPage = () => {
    navigate(`/crm/${title}`);
  };
  const [customFields, setCustomFields] = useState([]);

  useEffect(() => {
    const fields = [];

    if (props?.moduleData?.moduleName === constant.deals) {
      fields.push(
        {
          name: "account",
          schema: yup.string().required("Account is required"),
        }
      );
    }

    setCustomFields(fields);
  }, [props?.moduleData?.moduleName]);
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: yup.object().shape(
      generateValidationSchema(props?.moduleData?.fields || [], customFields)
    ),
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async () => {
    try {
      setIsLoading(true);
      let response = await postApi("api/form/add", {
        ...values,
        moduleId: props?.moduleData?._id,
        ...(props?.moduleData?.moduleName === constant.deals ? dealRelatedFields : {}),
      });
      if (response.status === 200) {
        formik.resetForm();
        // props.setAction((pre) => !pre);
        toast.success(`${singularizeLastWord(title)} Added Successfully`);
        navigate(`/crm/${title}`);
      }
    } catch (e) {
      toast.error("Something went wrong");
      console.log(e, "errors")
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Box className="commonPanelBody">
        <CustomForm
          moduleData={props.moduleData}
          values={values}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          setDealRelatedFields={setDealRelatedFields}
        />
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button
          className="nextBtn"
          variant="primary"
          onClick={handleSubmit}
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {constant.save}
        </Button>

      </Box>
    </>
  );
};

const CreateDynamic = () => {
  const hash = window.location.hash; // Get the part after the hash (#/crm/leads)
  const path = hash.replace("#", "").split("/"); // Remove the '#' and get the path
  const title = path[2].replace(/-/g, " ");
  const [moduleData, setModuleData] = useState({});
  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate(-1);
  };

  const tabsData = [{ label: `Create ${singularizeLastWord(title)}`, Icon: JobOpeningIcon }];

  const panelsData = [<TaskInformation moduleData={moduleData} />];

  useEffect(() => {
    (async () => {
      const result = await getApi(`api/custom-field/?moduleName=${title}`);
      const modulePageData = result?.data?.find(
        (item) => item?.moduleName === title
      );
      setModuleData(modulePageData);
    })();
  }, []);

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={`Create ${singularizeLastWord(title)}`}
    />
  );
};

export default CreateDynamic;
